import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { rxState } from '@rx-angular/state';
import { rxActions } from '@rx-angular/state/actions';
import { map, startWith, switchMap } from 'rxjs';

import { GamingStoriesApiService } from '../gaming-stories-api/gaming-stories-api.service';

export type LoadingState = 'loading' | 'loaded' | 'nodata';

@Injectable({
    providedIn: 'root',
})
export class InstagramSectionService implements OnAppInit {
    protected actions = rxActions<{
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        loadStories: void;
    }>();

    private gamingStoriesApiService = inject(GamingStoriesApiService);

    protected state = rxState<{
        stories: any;
        status: LoadingState;
    }>(({ set, connect }) => {
        set({ status: 'loading', stories: null });

        connect(
            this.actions.loadStories$.pipe(
                switchMap(() =>
                    this.gamingStoriesApiService.get('gamingstory/GetStories').pipe(
                        map((response) => {
                            if (Object.keys(response).length > 0) {
                                return {
                                    status: 'loaded' as LoadingState,
                                    stories: response,
                                };
                            }
                            return {
                                status: 'nodata' as LoadingState,
                                stories: null,
                            };
                        }),
                        startWith({
                            status: 'loading' as LoadingState,
                            stories: null,
                        }),
                    ),
                ),
            ),
        );
    });

    gamingStories$ = this.state.select('stories');
    newGameInstaStatus$ = this.state.select('status');

    onAppInit() {
        this.invalidateAndReloadGamingStories();
    }

    invalidateAndReloadGamingStories(): void {
        this.actions.loadStories();
    }
}
